import React from 'react'
import UIBody from '../../../Component/UI/UIBody'
import HomeBanner from './HomeBanner'
import HomeAbout from './HomeAbout'
import HomeBestSeller from './HomeBestSeller'
import HomeChooseUs from './HomeChooseUs'
import HomeOffer from './HomeOffer'
import HomeTestimonials from './HomeTestimonials'
import { useEffect } from 'react';
import AOS from "aos"

const HomePage = () => {
  useEffect(() => {
              AOS.init({
                duration: 800,
                easing: "ease-in-out", 
                once: false,
              });
            }, []);
  AOS.refresh();
  return (
    <UIBody 
        content={
            <div>
              <HomeBanner/>
              <HomeAbout />
              <HomeBestSeller />
              <HomeChooseUs />
              <HomeOffer />
              <HomeTestimonials />
            </div>
        }
    />
  )
}

export default HomePage
